export default __webpack_public_path__ + "static/media/cheshirecatalyst.fafb878d.png";